import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import SingleDates from '../calendar/SingleDates'
import RangeDates from '../calendar/RangeDates'
import { Selector } from '..'
// import SelectRange from '../calendar/SelectRange'
import colors from '../../styles/colors'
import TimePicker from '../timePicker/TimePicker'
import Dropdown from '../timePicker/Dropdown'

export default function TimeCalendarModal({
  title,
  show,
  handleClose,
  handleSubmit,
  setDaysOff,
  range,
  setRange,
  selectedDates,
  setSelectedDates,
  rangeDates,
  setRangeDates,
  datesToDisplay,
  setDatesToDisplay,
}) {
  const [showSingleDateCal, setShowSingleDateCal] = useState(true)

  const handleTabs = (flag) => {
    if (flag == 0) {
      setShowSingleDateCal(true)
    }
    if (flag == 1) {
      setShowSingleDateCal(false)
    }
  }

  return (
    <>
      <ModalContainer show={show} onHide={handleClose} size="lg">
        <Modal.Header className="px-4 border-0" closeButton>
          <ModalTitle className="ms-auto">{title}</ModalTitle>
        </Modal.Header>
        <TabsWrapper>
          <Selector
            leftText={'날짜선택'}
            rightText={'기간선택'}
            selectedIdx={showSingleDateCal == true ? 0 : 1}
            handleTab={handleTabs}
          />
        </TabsWrapper>
        {showSingleDateCal ? (
          <DateSelectionMultiCalModalBody>
            <SingleDates
              range={range}
              rangeDates={rangeDates}
              setSelectedDates={setSelectedDates}
              selectedDates={selectedDates}
              datesToDisplay={datesToDisplay}
              setDatesToDisplay={setDatesToDisplay}
            />
          </DateSelectionMultiCalModalBody>
        ) : (
          <MultiCalModalBody>
            <RangeDates
              range={range}
              setRange={setRange}
              setDaysOff={setDaysOff}
              rangeDates={rangeDates}
              setRangeDates={setRangeDates}
            />
          </MultiCalModalBody>
        )}
        <ModalFooter />
        {title == '영업 임시중지' ? (
          <>
            <TimeAnnouncementWrapper>
              <HeaderLabel>시간</HeaderLabel>
              <TimeSettingWrapper>
                <StartTime>
                  <LabelText>시작</LabelText>
                  <TimePicker />
                </StartTime>
                <EndTime>
                  <LabelText>종료</LabelText>
                  <TimePicker />
                </EndTime>
              </TimeSettingWrapper>
            </TimeAnnouncementWrapper>
            <ModalFooter />

            <TimeAnnouncementWrapper>
              <HeaderLabel>영업 임시중지 사유</HeaderLabel>
              <AnnouncementWrapper>
                <Dropdown />
              </AnnouncementWrapper>
            </TimeAnnouncementWrapper>
          </>
        ) : (
          ''
        )}

        {title == '임시휴무' ? (
          <TimeAnnouncementWrapper>
            <HeaderLabel>영업 임시중지 사유</HeaderLabel>
            <AnnouncementWrapper>
              <Dropdown />
            </AnnouncementWrapper>
          </TimeAnnouncementWrapper>
        ) : (
          ''
        )}

        <ModalFooter />
        <ModalFooterWrapper>
          <SubmitButton onClick={() => handleSubmit()}>
            <SubmitButtonTxt>적용</SubmitButtonTxt>
          </SubmitButton>
        </ModalFooterWrapper>
      </ModalContainer>
    </>
  )
}

const TimeAnnouncementWrapper = styled.div`
  padding: 20px;
`
const StartTime = styled.div`
  display: flex;
  @media ${(props) => props.theme.mobile} {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
`
const EndTime = styled.div`
  display: flex;
  @media ${(props) => props.theme.mobile} {
    display: flex;
    align-items: center;
  }
`
const HeaderLabel = styled.span`
  /* width: 29px; */
  /* height: 24px; */
  margin: 20px 20px 15px 0;
  /* object-fit: contain; */
  /* font-family: NotoSansKR; */
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  @media ${(props) => props.theme.mobile} {
    margin: 0px;
  }
`
const AnnouncementWrapper = styled.div`
  .css-t3ipsp-control,
  .css-13cymwt-control {
    width: 100%;
    margin-top: 15px;
  }
  /* .css-b62m3t-container {
    margin-right: 8px;
  } */
`

const TimeSettingWrapper = styled.div`
  display: flex;
  margin-top: 15px;
  justify-content: flex-start;
  /* gap: 38px; */
  gap: 1.5em;
  @media ${(props) => props.theme.mobile} {
    flex-wrap: wrap;
    justify-content: left;
  }

  .css-t3ipsp-control,
  .css-13cymwt-control {
    /* width: 103px; */
    border-color: gray;
    @media ${(props) => props.theme.mobile} {
      /* width: 169px;
      height: 36px; */
      width: 100%;
      height: 100%;
    }
  }
  /* .css-b62m3t-container {
    margin-right: 8px;
  } */
`
const LabelText = styled.span`
  display: flex;
  align-items: center;
  margin: 0px 20px 0px 0px;
  /* margin: 2px 20px 2px 5px; */
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8a8a8a;
  @media ${(props) => props.theme.mobile} {
    margin: 0px 20px 0px 0px;
    font-size: 14px;
  }
`

const ModalContainer = styled(Modal)`
  .modal-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal-content {
    width: 619px;
    height: auto;

    @media ${(props) => props.theme.mobile} {
      width: 360px;
      height: auto;
    }
  }
`
const MultiCalModalBody = styled(Modal.Body)`
  @media ${(props) => props.theme.mobile} {
    height: 700px;
  }
`
const DateSelectionMultiCalModalBody = styled(Modal.Body)`
  @media ${(props) => props.theme.mobile} {
    height: auto;
  }
`
const TabsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
`
const ModalTitle = styled(Modal.Title)`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${colors.BK};
`
const ModalFooterWrapper = styled(Modal.Footer)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: none;
  padding-top: 0;
`
const ModalFooter = styled.div`
  width: 578px;
  height: 1px;
  border: solid 1px #f3f3f3;
  background-color: #e5e5e5;
  align-self: center;
  @media ${(props) => props.theme.mobile} {
    width: 320px;
    height: 1px;
    background-color: #f3f3f3;
  }
`
const SubmitButton = styled.div`
  width: 320px;
  height: 50px;
  border-radius: 8px;
  background-color: ${colors.mainG};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  cursor: pointer;
`
const SubmitButtonTxt = styled.span`
  font-family: NotoSansKR;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${colors.W1};
`
